import { type AxiosInstance } from "axios";
import { type SavedAddress } from "./userService";

export interface ShippingRate {
  id: string;
  carrier: string;
  service: string;
  packaging: string;
  packagingType: "own" | "carrier";
  deliveryEstimate: string;
  price: number;
  savingsPercent: number;
}

export type ShippingAddress = SavedAddress["address"];

export interface PackageDetails {
  // Pounds.
  weight: number;
  // Inches.
  length: number;
  width: number;
  height: number;
}

export interface ShippingRatesPayload {
  fromAddress: ShippingAddress;
  toAddress: ShippingAddress;
  packageDetails: PackageDetails;
}

export const getShippingRates = async (
  axiosInstance: AxiosInstance,
  payload: ShippingRatesPayload,
): Promise<ShippingRate[]> => {
  const { data } = await axiosInstance.post("/shipping/rates", payload);
  return data;
};

export interface Discount {
  code: string;
  promotionCodeId: string;
  percentOff: number | null;
  amountOff: number | null;
  discountAmount: number;
  subtotal: number;
  total: number;
}

export interface DiscountPayload {
  code: string;
  rateId: string;
}

export const applyDiscountCode = async (
  axiosInstance: AxiosInstance,
  payload: DiscountPayload,
): Promise<Discount> => {
  const { data } = await axiosInstance.post("/shipping/discount", payload);
  return data;
};
